const initialState ={
  refresh:0
}

const reducer = (state = initialState, action) => {
  let newState= {...state};
  switch(action.type){
    case 'REQUEST_CREATE_CUSTOM_DEAL_FIELD_SUCCESS':
    case 'REQUEST_GET_CUSTOM_DEAL_FIELD_SUCCESS':
    case 'REQUEST_UPDATE_CUSTOM_DEAL_FIELD_SUCCESS':
      if(newState.custom_fields==undefined){newState.custom_fields={}}
      newState.custom_fields[action.val.id]={...action.val};
      newState.refresh+=1;
      break;
    case 'REQUEST_INDEX_CUSTOM_DEAL_FIELDS_SUCCESS':
      if(newState.custom_fields==undefined){newState.custom_fields={}}
      for(let x of action.val){if(newState.custom_fields[x.id]==undefined){newState.custom_fields[x.id]={}} newState.custom_fields[x.id]={...newState.custom_fields[x.id], ...x};}
      newState.refresh+=1;
      break;
    }
  return newState;
}

export default reducer;
